import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LoginHeader = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ position: "relative", zIndex: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingX: 4,
          paddingY: 2.8,
          backgroundColor: "#ffffff",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 800,
              letterSpacing: "0.5px",
              cursor: "pointer",
              color: "text.primary",
            }}
            onClick={() => navigate("/")}
          >
            Cory Hixson Tutoring
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "100%",
          left: 0,
          width: "100%",
          height: "60px",
          background: "linear-gradient(to bottom, #ffffff, rgba(255,255,255,0))",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};

export default LoginHeader;